import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ChangePasswordState {
  loading: boolean;
  success: any;
  error: any | null;
}

const initialState: ChangePasswordState = {
  loading: false,
  success: null,
  error: null,
};

const changePasswordSlice = createSlice({
  name: 'changePassword',
  initialState,
  reducers: {
    changePasswordRequest(
      state,
      action: PayloadAction<{
        accountId: string;
        customerId: string;
        username: string;
        oldPassword: string;
        newPassword: string;
        verifyPassword: string;
        recaptchaToken?:string|null|undefined;
        }>
    ) {
      state.loading = true;
      state.success = null;
      state.error = null;
    },
    changePasswordSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.success = action.payload;
      state.error = null;
    },
    changePasswordFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.success = null;
      state.error = action.payload;
    },
    resetChangePasswordState(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const {
  changePasswordRequest,
  changePasswordSuccess,
  changePasswordFailed,
  resetChangePasswordState,
} = changePasswordSlice.actions;

export default changePasswordSlice.reducer;
